var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTrash69360Alf = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6848 2.5C16.0245 2.5 16.306 2.75388 16.3544 3.08443L16.3617 3.18571V5.24286H20.4138C21.2892 5.2304 21.3272 6.50846 20.528 6.60822L20.4138 6.61429H19.0694V18.9571C19.0694 20.4555 17.7929 21.6146 16.2772 21.6955L16.1079 21.7H8.49254C6.96055 21.7 5.62935 20.5944 5.53622 19.1222L5.53102 18.9571V6.61429H4.18665C3.81367 6.61909 3.50703 6.31806 3.50008 5.93543C3.49466 5.58469 3.75529 5.29041 4.09283 5.24802L4.18665 5.24286H8.23869V3.18571C8.23869 2.84161 8.48932 2.55644 8.81563 2.50744L8.91561 2.5H15.6848ZM17.7156 6.61429H6.88486V18.9571C6.88486 19.64 7.47369 20.2523 8.3291 20.322L8.49254 20.3286H16.1079C16.9954 20.3286 17.6364 19.7564 17.7087 19.0842L17.7156 18.9571V6.61429ZM13.6547 10.0525C13.6418 9.16502 14.9047 9.12644 15.0027 9.9367L15.0086 10.0525V16.8904C15.014 17.2682 14.7155 17.5789 14.3384 17.5859C13.9922 17.5908 13.7017 17.3267 13.6598 16.9853L13.6547 16.8904V10.0525ZM9.59321 10.0525C9.58026 9.16502 10.8425 9.12644 10.9411 9.9367L10.9471 10.0525V16.8904C10.9518 17.2682 10.6533 17.5789 10.2762 17.5859C9.92998 17.5908 9.64005 17.3267 9.5983 16.9853L9.59321 16.8904V10.0525ZM15.0079 3.87143H9.59253V5.24286H15.0079V3.87143Z",
    fill: "#0054A4"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTrash69360Alf);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/trash6936-0alf.75e40a3a452045b7f6ab09ccec521c1a.svg";